import {
  GridViews,
  WcgAdvancedFilter,
  WcgAdvancedFilterType,
} from '@wcg/frontend-framework';
import { camelCase } from 'lodash';
import { GridView, GridViewAdvancedFilterEntry } from '../types';

export function gridViewsMapper(view: GridView): GridViews {
  return {
    advancedFilters: view.advanced_filters ?? {},
    columns: view.columns ?? {},
    default: view.default ?? false,
    gridType: view.grid_type,
    id: view.id!,
    name: view.name.toString(),
    pagination: view.pagination ?? 0,
    searchString: view.search_string || '',
    sorted: view.sorted ?? null,
  };
}

export function optimizedGridAdvancedFilters(
  advancedFilters: WcgAdvancedFilter,
): GridViewAdvancedFilterEntry {
  return Object.entries(advancedFilters).reduce((acc, [key, value]) => {
    acc[key] = {
      key: value.columnKey,
      value: value.value,
    };

    if (
      (value.type === WcgAdvancedFilterType.DateRange ||
        value.type === WcgAdvancedFilterType.Date_Range) &&
      value.start &&
      value.end
    ) {
      acc[key].start = value.start;
      acc[key].end = value.end;
      acc[key].formatted = value.formatted ?? `${value.start} - ${value.end}`;
      acc[key].value = '';
    }

    return acc;
  }, {} as GridViewAdvancedFilterEntry);
}

export function mapAdvancedFilterByGridView(
  advancedFilters: WcgAdvancedFilter,
  gridViewAdFilter: GridViewAdvancedFilterEntry,
) {
  const _advancedFilters: WcgAdvancedFilter = { ...advancedFilters };

  for (const key of Object.keys(advancedFilters)) {
    const gridFilter = gridViewAdFilter[camelCase(key)];
    const originalValue = advancedFilters[key]?.value;

    const fallbackValue = Array.isArray(originalValue)
      ? []
      : typeof originalValue === 'string'
        ? ''
        : undefined;

    _advancedFilters[key] = {
      ...advancedFilters[key],
      value: gridFilter?.value ?? fallbackValue,
    };

    if (
      advancedFilters[key]?.type === WcgAdvancedFilterType.DateRange ||
      advancedFilters[key]?.type === WcgAdvancedFilterType.Date_Range
    ) {
      delete _advancedFilters[key].start;
      delete _advancedFilters[key].end;
      delete _advancedFilters[key].formatted;

      if (gridFilter?.start && gridFilter?.end) {
        _advancedFilters[key] = {
          ...advancedFilters[key],
          start: gridFilter.start,
          end: gridFilter.end,
          formatted: gridFilter.formatted,
          value: fallbackValue,
        };
      }
    }
  }

  return _advancedFilters;
}
